import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ParkingProcessInfoClient, ParkingProcessInfoDTO } from '../models/models.swagger.generated';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ParkingProcessInfoService {

  public parkingProcessInfos: ParkingProcessInfoDTO[];

  constructor(private parkingProcessInfoClient: ParkingProcessInfoClient) {
  }

  public getParkingProcessInfos(): Observable<ParkingProcessInfoDTO[]> {
    return this.parkingProcessInfoClient.getParkingProcessInfos()
      .pipe(
        tap(info => this.parkingProcessInfos = info?.sort(
          (a, b) => a.activeCheckinInfo.registrationDateTime.toMillis() - b.activeCheckinInfo.registrationDateTime.toMillis())),
      );
  }
}
